import React from 'react';
import { HighlightButton } from 'components/common/button';
import { t } from 'locale';
import { assetUrl } from 'utils/appUrl';
import { openInBrowser } from 'utils/url';
export const LoginButton = (props) => (React.createElement(HighlightButton, Object.assign({ size: "medium", icon: "log-in" }, props), t('patreonLogin')));
export const LogoutButton = (props) => (React.createElement(HighlightButton, Object.assign({ size: "medium", icon: "log-out" }, props), t('patreonLogout')));
export const SignupButton = () => (React.createElement("button", { onClick: () => openInBrowser('https://www.patreon.com/metastream'), style: { fontSize: 0 }, "aria-label": t('patreonPledge') },
    React.createElement("img", { src: assetUrl('images/become_a_patron_button.png'), width: "170px", height: "40px", alt: "" })));
